import React, { Component } from 'react'
import TextArea from '../../../../../../Util/TextArea/TextArea'
import './SendTextMessage.css'
import { motion } from 'framer-motion'
import {backdropTransition, popupTransition, transitionDuration} from '../../../../../../Util/PageTransitions'
import JSONpackage from '../../../../../../../package.json'

export default class SendTextMessage extends Component {
    constructor() {
        super()
        this.state = {
            message: '',
            route: ''
        }
    }

    componentDidMount() {
        this.getProductionHandler()
    }

    getProductionHandler = () => {
        if (JSONpackage.production) {
          this.setState({ route: 'https://BigMPizza.com:443' })
        } else {
          this.setState({ route: 'http://localhost:4000' })
        }
    }

    confirmSendMessage = () => {
        let header = 'Confirm Action'
        let body = `Send a text message to ${this.props.phoneNumberList.length} people?`
        this.props.displayConfirmationNotification(header, body, this.sendMessageHandler)
    }

    sendMessageHandler = () => {
        // axios.post(`${this.state.route}/api/sendMultipleSMS`, {
        //     recipients: this.props.phoneNumberList,
        //     textmessage: this.state.message
        // })
        // .then(() => {
        //     this.props.updateMassTextHistory(this.props.phoneNumberList, this.state.message)
        //     this.props.displayMessageHandler('Message Sent')
        //     this.props.closeWindow()
        // })
        // .catch((error) => {
        //     this.props.displayMessageHandler('Message Failed to Send')
        // })
    }

    render() {
        return (
            <motion.div className='sendTextMessagePopupPageContainer' initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}>
                <div className='sendTextMessagePopupBackdrop' onMouseDown={this.props.closeWindow}/>
                <motion.div className='sendTextMessagePopupContainer' initial={popupTransition.initial} animate={popupTransition.in} exit={popupTransition.out} transition={{ duration: transitionDuration }}>
                    <div className='adminFiltersPagePopupHeader'>
                        <h2 className='adminFiltersPagePopupHeaderText'>Send Text Message</h2>
                        <button className='adminFiltersPagePopupHeaderCloseButton' onClick={this.props.closeWindow}>&#10005;</button>
                    </div>
                    <div className='sendTextMessageBodyContainer'>
                        <p className='sendTextMessageRecipientsList'>To: {this.props.phoneNumberList.length === 0 ? 'Nobody' : this.props.phoneNumberList.length <= 3 ? this.props.phoneNumberList.map((value, index) => `${value.name}${index === this.props.phoneNumberList.length - 1 ? '' : ', '}`): `${this.props.phoneNumberList.length} Recipients`}</p>
                        <TextArea value={this.state.message} title={'Message'} containerStyles={{width: '90%', margin: '0px', marginLeft: '10px'}} onChange={(e) => this.setState({message: e.target.value})}/>
                    </div>
                    <div className='adminFiltersPagePopupFooterContainer'>
                        <button className='adminFiltersPagePopupFooterButton secondaryButton' onClick={this.props.closeWindow}>Cancel</button>
                        <button className='adminFiltersPagePopupFooterButton primaryButton' onClick={this.confirmSendMessage}>Send Message</button>
                    </div>
                </motion.div>
            </motion.div>
        )
    }
}
